import { format } from "date-fns";
import { uk } from "date-fns/locale";

type TDate = string | number | Date | undefined | null;

export const toReadableDMY = (date: TDate) => {
  if (!date) {
    return "";
  }
  return format(date, "d, MMM yyyy", { locale: uk });
};

export const toReadableDay = (date: TDate) => {
  if (!date) {
    return "";
  }
  const dayNames = ["Нд", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"];
  const dayIndex = Number(format(date, "i"));
  return dayNames[dayIndex % 7];
};

export const toReadableWeek = (date: TDate) => {
  if (!date) {
    return "";
  }
  return format(date, "dd.MM", { locale: uk });
};

export const toReadableMonth = (date: TDate) => {
  if (!date) {
    return "";
  }
  return format(date, "LLL", { locale: uk });
};

type GroupBy = "day" | "week" | "month";

export const dateToReadable = (date: TDate, type: GroupBy) => {
  switch (type) {
    case "day":
      return toReadableDay(date);
    case "month":
      return toReadableMonth(date);
    default:
      return toReadableWeek(date);
  }
};
